export enum InspectorRole {
  Inspector = 0,
  QualityRepresentive = 2,
  WarehouseRepresentive = 4,
}
